import React from 'react'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { withRouter } from 'react-router-dom'
import { compose } from 'utils/compose'
// eslint-disable-next-line no-restricted-imports
import { withApollo } from '@apollo/client/react/hoc'
import { useSchoolAccessRetrieval } from './SchoolAccessRetrieval.hooks'
import {
  ProgressDots,
  CustomButtons,
  StudentSelect,
  HelpSection
} from 'components/family-paying-access'
import {
  ModalNotYourSchool,
  ModalRequestErrorHelper,
  ModalSubscriptionPaid
} from 'components/lib/modals'
import {
  ContainerOnlyBigScreens,
  ContainerOnlySmallScreens
} from 'styles/common/Common.styles'
import {
  BackArrowButton,
  PageWrapper,
  Content,
  Title,
  SubTitle
} from './SchoolAccessRetrieval.styles'

const SchoolAccessRetrieval = ({ match, client, ...props }) => {
  const { history } = props

  const { handlers, states } = useSchoolAccessRetrieval({
    match,
    client,
    history
  })
  const {
    namesFound,
    noNameFound,
    selectedName,
    showHelpModal,
    showRequestErrorModal,
    isModalSubscriptionPaidOpen,
    shouldSearchByEnrollmentNumber
  } = states
  const {
    searchMatchingNames,
    handleSubmit,
    handleOptionClicked,
    eraseField,
    toggleHelpModal,
    toggleAlreadyRegisteredModal
  } = handlers

  return (
    <PageWrapper>
      <ModalRequestErrorHelper
        showModal={showRequestErrorModal}
        dismissModal={toggleAlreadyRegisteredModal}
      />
      <ModalNotYourSchool
        isSchool={false}
        showModal={showHelpModal}
        dismissModal={toggleHelpModal}
      />
      <BackArrowButton
        data-testid="back-arrow"
        iconName="arrow-left"
        bgColor={tokens.colors.white}
        bgColorHover={tokens.colors.black1}
        iconColor={tokens.colors.black5}
        onClick={() => history.goBack()}
      />
      <ModalSubscriptionPaid showModal={isModalSubscriptionPaidOpen} />
      <ContainerOnlySmallScreens>
        <ProgressDots currentDotIndex={1} numberOfDots={3} />
      </ContainerOnlySmallScreens>
      <Content>
        <Title>Para qual estudante?</Title>
        <SubTitle>
          Selecione abaixo para qual estudante deseja realizar a assinatura.
        </SubTitle>
        <StudentSelect
          noNameFound={noNameFound}
          selectedName={selectedName}
          eraseField={eraseField}
          searchMatchingNames={searchMatchingNames}
          namesFound={namesFound}
          handleOptionClicked={handleOptionClicked}
          shouldSearchByEnrollmentNumber={shouldSearchByEnrollmentNumber}
        />
        {noNameFound && <HelpSection />}
        <CustomButtons
          handleSubmit={handleSubmit}
          selectedName={selectedName}
          handleOpenModal={toggleHelpModal}
        />
        <ContainerOnlyBigScreens>
          <ProgressDots currentDotIndex={1} numberOfDots={3} />
        </ContainerOnlyBigScreens>
      </Content>
    </PageWrapper>
  )
}

export default compose(withRouter, withApollo)(SchoolAccessRetrieval)
